module.exports = __webpack_public_path__ + "static/img/ent-51.9f7342d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-51.jpg
// module id = Hl21
// module chunks = 52